"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpAssessmentTemplateCard: {
        questions: 'Questions',
        sections: 'Sections',
        schedule: 'Schedule',
        types: {
            assessment: 'Assessment',
            diagnostic: 'Diagnostic',
            handout: 'Handout',
        },
        curriculums: {
            em: 'Eureka Math',
            emtx: 'Eureka Math Texas',
            ww: 'Wit & Wisdom',
            phd: 'Science',
            phdtexas: 'Science Texas',
            phdpilot: 'Science Pilot',
            geo: 'Geodes',
        },
        ariaLabel: {
            card: 'Assessment, {{curriculum}} {{name}}, questions {{questions}}, sections {{sections}}',
            diagnosticCard: 'Assessment, {{curriculum}} {{name}}, sections {{sections}}',
            scheduleButton: 'schedule assessment {{name}}',
        },
    },
};
